<template>
  <div class="card" @click="active" :class="{'card-active': list.active}">
    <p class="tip" :class="{'tip-active': list.active}">金额</p>
    <p class="new-price" :class="{'np-Active': list.active}">￥{{list.newprice / 100}}</p>
    <p class="old-price" :class="{'op-Active': list.active}">原价 : {{list.oldprice}}</p>
  </div>
</template>

<script>
export default {
  props: ['list'],
  name: 'card',
  methods: {
    active: function () {
      this.list.active = !this.list.active
    }
  }
}
</script>

<style scoped>
.card {
  width: 358px;
  height: 242px;
  font-size: 0;
  border-radius: 10px;
  box-sizing: border-box;
  margin: 0 20px;
  padding: 10px;
  font-size: 100px;
  color: #fff;
  cursor: pointer;
  border-radius: 10px;
  border: 1px solid #dcdcdc;
}
.tip {
  line-height: 50px;
  font-size: .24em;
  color: #333333;
  padding-left: 20px;
}
.new-price {
  font-size: .42em;
  line-height: 100px;
  text-align: center;
  color: #f8c450;
}
.old-price {
  font-size: .24em;
  text-align: center;
  color: #f8c450;
}

.card-active {
  background: url('../../../../static/images/payCard.png');
  background-size: 100% 100%;
  border: 0;
}
.tip-active {
  color: #fdf0da;
}
.np-Active {
  color: #fff;
}
.op-Active {
  color: #fdf0da;
}
@media (max-width: 1199px) {

}
@media screen and (max-width: 801px){
  .card {
    width: 100%;
    margin: 0 0 10px 0;
    padding: 10px;
    font-size: 100px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/mall/slot/card.vue